module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/speaker-regular.b8ce5f3.png";